<template>
  <div id="app" class="u-bg-grey">
    <symbols-svg />
    <transition name="t-fader">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import App from './App'
import SymbolsSvg from '@/components/SymbolsSvg'

export default {
  name: 'App',

  mixins: [App],

  components: {
    SymbolsSvg
  }
}
</script>

<style lang="stylus" src="./styles/theme.styl"/>

<!-- <style lang="stylus">
@import '~@/styles/settings/variables'

</style> -->
